var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as types from './roomsActionTypes';

var initialState = {
    isInProgress: false,
    rooms: [],
    hasError: false,
    errorMessage: ''
};

var createRoom = function createRoom(state, action) {
    return _extends({}, state, {
        isInProgress: true
    });
};

var createRoomSuccess = function createRoomSuccess(state, action) {
    return _extends({}, state, {
        isInProgress: false
    });
};

var createRoomError = function createRoomError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        isInProgress: false,
        hasError: true,
        errorMessage: errorMessage
    });
};

var retrieveRooms = function retrieveRooms(state, action) {
    var key = action.key,
        roomName = action.roomName,
        metaData = action.metaData,
        counter = action.counter,
        lastUpdate = action.lastUpdate;


    var rooms = [].concat(state.rooms, [{
        chatroomId: key,
        chatroomName: metaData,
        counter: counter,
        lastUpdate: lastUpdate
    }]);

    rooms.sort(function (a, b) {
        return b.lastUpdate - a.lastUpdate;
    });

    return _extends({}, state, {
        rooms: rooms
    });
};

var resetRoomsList = function resetRoomsList(state, action) {
    return _extends({}, state, {
        rooms: []
    });
};

var reorderRooms = function reorderRooms(state, action) {
    var rooms = action.rooms;

    return _extends({}, state, {
        rooms: rooms
    });
};

export var roomsReducers = function roomsReducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case types.CREATE_ROOM:
            return createRoom(state, action);
        case types.CREATE_ROOM_SUCCESS:
            return createRoomSuccess(state, action);
        case types.CREATE_ROOM_ERROR:
            return createRoomError(state, action);
        case types.RETRIEVE_ROOMS:
            return retrieveRooms(state, action);
        case types.RESET_ROOMS_LIST:
            return resetRoomsList(state, action);
        case types.REORDER_ROOMS_SUCCESS:
            return reorderRooms(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Rooms/roomsReducers.js
// module id = 229
// module chunks = 0